export default {
  setJWT (state, payload) {
    state.jwt = payload
  },
  setExp (state, payload) {
    state.exp = payload
  },
  setBenefitsCities (state, payload) {
    state.benefitsCities = payload
  },
  clear (state) {
    state.benefitsCities = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/popupciudad/mutations.js